import React from 'react';
import { object, string } from 'yup';

import MESSAGES from '../../../locales';
import { Form, Input, Link, Button } from '../../_shared';

const Schema = object().shape({
  code: string().required('Please input verification code in your inbox.'),
});

const VerifyEmailForm = (props) => {
  return (
    <Form schema={Schema} onSubmit={props.onSubmit}>
      <h3 className="mb-6 text-3xl text-center font-bold tracking-widest leading-7 uppercase">
        Verify Email
      </h3>

      <Input
        id="code"
        name="code"
        label="Code"
        type="text"
        autoComplete="off"
        required
      />
      {props.success && (
        <div className="text-green text-center text-sm mt-6">
          Resent code successfully!
        </div>
      )}
      {props.error && !props.success && (
        <div className="text-red text-center text-sm mt-6">{props.error}</div>
      )}
      <div className="flex flex-col mt-6">
        <Button
          type="misc"
          className="p-3 px-9 bg-black text-white font-bold"
          caption="VERIFY"
          busy={props.isSubmitting}
        />
        <div className="my-3" />
        <Button
          type="misc"
          className="p-3 px-9 bg-black text-white font-bold"
          caption="RESEND CODE"
          busy={props.isResending}
          onClick={props.onResendCode}
        />
        <Button
          type="misc"
          className="text-black underline cursor-pointer mt-4 text-base"
          caption="RETURN TO SIGN IN"
          onClick={props.onReturn}
        />
      </div>
    </Form>
  );
};

export default VerifyEmailForm;
